var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M18.5714 -0.000183105H1.42411C0.638393 -0.000183105 0 0.647139 0 1.44178V18.5579C0 19.3525 0.638393 19.9998 1.42411 19.9998H18.5714C19.3571 19.9998 20 19.3525 20 18.5579V1.44178C20 0.647139 19.3571 -0.000183105 18.5714 -0.000183105ZM6.04464 17.1427H3.08036V7.59803H6.04911V17.1427H6.04464ZM4.5625 6.29446C3.61161 6.29446 2.84375 5.52214 2.84375 4.57571C2.84375 3.62928 3.61161 2.85696 4.5625 2.85696C5.50893 2.85696 6.28125 3.62928 6.28125 4.57571C6.28125 5.5266 5.51339 6.29446 4.5625 6.29446ZM17.1562 17.1427H14.192V12.4998C14.192 11.3927 14.1696 9.96857 12.6518 9.96857C11.1071 9.96857 10.8705 11.1739 10.8705 12.4195V17.1427H7.90625V7.59803H10.75V8.9016H10.7902C11.1875 8.1516 12.1563 7.36142 13.5982 7.36142C16.5982 7.36142 17.1562 9.3391 17.1562 11.9105V17.1427Z",
    fill: "#021C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.c4c905aeab630a18e6f69c93ea3e5355.svg";
export { ForwardRef as ReactComponent };